import { CompanyRegistrationType } from "@/graphql/codegen/graphql"

export const CompanyRegistrationTypeListToLabel: Record<CompanyRegistrationType, string> = {
  [CompanyRegistrationType.Federal]: "Federal Registration",
  [CompanyRegistrationType.State]: "State Registration",
  [CompanyRegistrationType.Local]: "Local Registration",
}

export const SET_DIALOG = "SET_DIALOG"
export const SET_TAB = "SET_TAB"
export const SET_REGISTRATION = "SET_REGISTRATION"
export const RESET = "RESET"
